import React from 'react';
import proptypes from 'prop-types';
import { Box, IconButton, Stack, XCloseIcon } from '@metarouter-private/mr-mui';
import ClusterSelect from 'app/components/cluster-select';

import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import DRAWER_MODES from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider/DRAWER_MODES';
import PipelineSelect from './PipelineSelect';
import useTrackWithUser from '@ion/api/hooks/useTrackWithUser';

const SELECT_WIDTH = 240;

// Right-aligned header controls: in Advanced mode the pipeline select appears
// to the left of the cluster, which stays pinned beside the close button so
// nothing shifts when the mode changes.
export default function DrawerHeaderControls({ onCloseDrawer }) {
  const { clusterId } = useTransformPlaybookContext();
  const { mode, onClusterChange } = useTestPlaybookDrawerContext();
  const [trackClusterSelected] = useTrackWithUser('cluster_selected');

  const handleOnChange = selectedClusterId => {
    trackClusterSelected();
    onClusterChange(selectedClusterId);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {mode === DRAWER_MODES.ADVANCED && (
        <Box width={SELECT_WIDTH}>
          <PipelineSelect />
        </Box>
      )}
      <Box width={SELECT_WIDTH}>
        <ClusterSelect variant="outlined" size="small" fullWidth onChange={handleOnChange} defaultValue={clusterId} />
      </Box>
      <IconButton onClick={onCloseDrawer} data-test-id="closeTestPlaybookDrawer">
        <XCloseIcon />
      </IconButton>
    </Stack>
  );
}

DrawerHeaderControls.propTypes = {
  onCloseDrawer: proptypes.func.isRequired,
};
